import { LeafIcon } from "./icon.component.js";
customElements.define("leaf-icon", LeafIcon);
export {
  LeafIcon
};
//# sourceMappingURL=icon.js.map
